export default "__VITE_PUBLIC_ASSET__bda18da8__"